import { isTenant } from '@repo/utils';

export function canAccessCalculators() {
  return isTenant('pfida');
}
